import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import DomainListItem from '../../components/DomainListItem'
import {TransitionGroup} from 'react-transition-group'


import MediaQuery from 'react-responsive'
import {addDomainToCartAndRefresh} from "../../actions/Cart";
import {getRemainingInclusiveDomains} from "../../selectors/Cart";
import {isAgencyCustomer} from "../../selectors/Mode";
import {delve} from "../../util/util";


class DomainListing extends Component {

    static propTypes = {
        listData: PropTypes.array.isRequired,
        domainsLoading: PropTypes.array,
        domainsAvailable: PropTypes.array,
        domainsGone: PropTypes.array,
        tableLabel: PropTypes.string.isRequired,
        staggerOffset: PropTypes.number
    }

    getDomainListUiState = (key) => {
        if (this.props.domainsLoading && this.props.domainsLoading.indexOf(key) !== -1) {
            return 'loading'
        } else if (this.props.domainsAvailable && this.props.domainsAvailable.indexOf(key) !== -1) {
            return 'available'
        } else if (this.props.domainsGone && this.props.domainsGone.indexOf(key) !== -1) {
            return this.props.hideDomainsGone ? 'gone-hide' : 'gone'
        }
        return ''
    }

    isDomainGettingAddedToCart = (domainName) => {

        return this.props.domainsGettingAddedToCart.includes(domainName)

    }

    render() {

        let listItems = []
        let inDelay = 0 - (this.props.staggerOffset ? this.props.staggerOffset : 0) * 0.1

        this.props.listData.forEach(domainEnding => {


            const fullDomainName = this.props.queriedDomain + "." + domainEnding
            const domainEndingData = this.props.domainData[domainEnding];

            const agencyArticle = this.props.isAgencyCustomer ? domainEndingData.agencyArticle : null;
            let setupFee, priceMonthly;

            if (agencyArticle) {
                setupFee = delve(agencyArticle, "price.default.setupFee");
                priceMonthly = delve(agencyArticle, "price.default.net");
            } else {
                setupFee = domainEndingData.setupFee;
                priceMonthly = domainEndingData.price;
            }

            // only show items that are not in cart already
            listItems.push(
                <DomainListItem
                    uiState={this.getDomainListUiState(domainEnding)}
                    key={this.props.queriedDomain + '.' + domainEnding}
                    remainingInclusiveDomains={this.props.remainingInclusiveDomains > 0 && domainEndingData.isAllowedAsInclusiveDomain !== 0 ? this.props.remainingInclusiveDomains : 0}
                    domainName={this.props.queriedDomain}
                    domainEnding={domainEnding}
                    domainPriceMonthly={"" + priceMonthly}
                    domainPriceSetup={"" + setupFee}
                    animationInDelay={inDelay}
                    isGettingAddedToCart={this.isDomainGettingAddedToCart(fullDomainName)}
                    onClick={() => {
                        this.props.addDomainToCart(fullDomainName)
                    }}
                />
            )
            inDelay += 0.1

        })

        return (

            <TransitionGroup
                component="div"
                className="domain-listing"
            >
                <div className="domain-listing__header">
                    <div><h2>{this.props.tableLabel}</h2></div>
                    <div className={"domain-listing__header__price"}>einmalig</div>
                    <MediaQuery maxWidth={759}>{(isMatching) => {
                        return isMatching ? <div className={"domain-listing__header__price"}>mtl.</div> : <div className={"domain-listing__header__price"}>monatlich</div>
                    }}</MediaQuery>
                </div>
                {listItems}
            </TransitionGroup>

        )

    }

}

const mapStateToProps = (state) => {

    return {
        queriedDomain: state.domainCheck.queriedDomain,
        domainData: state.domainCheck.topLevelDomains.data,
        furtherDomainLimit: state.domainCheck.furtherDomainLimit,
        domainsAvailable: state.domainCheck.domainsAvailable[state.domainCheck.queriedDomain],
        domainsGone: state.domainCheck.domainsGone[state.domainCheck.queriedDomain],
        domainsLoading: state.domainCheck.domainsLoading[state.domainCheck.queriedDomain],
        domainsGettingAddedToCart: state.domainCheck.domainsGettingAddedToCart,
        remainingInclusiveDomains: getRemainingInclusiveDomains(state),
        hideDomainsGone: state.domainCheck.hideDomainsGone,
        isAgencyCustomer: isAgencyCustomer(state)
    }

}

const mapDispatchToProps = (dispatch) => {

    return {
        addDomainToCart: (domainNameAndEnding) => {
            dispatch(addDomainToCartAndRefresh(domainNameAndEnding))
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(DomainListing)


/** WEBPACK FOOTER **
 ** ./src/containers/domainstep/DomainListing.js
 **/